module.exports = "<template>\r\n  Your session has expired. Please log in again.\r\n</template>";